import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "right-jt",
  "use": "right-jt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"right-jt\"><defs><style type=\"text/css\"></style></defs><path d=\"M298.667 761.088v49.579l426.667-257.195v-43.392l-426.667-254.080v52.694l389.035 223.104-389.035 229.291z\" p-id=\"4408\" fill=\"#6bf70d\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/right-jt.svg
// module id = BB54
// module chunks = 38